import Vue from 'vue';
import Router from 'vue-router';
import ZrssPrijavnica from './views/prijavnica.vue';
import ZrssPrijavnicaSS from './views/prijavnica-ss.vue'; //Študijska srečanja
import ZrssPrijavnicaNAK from './views/prijavnica-nak.vue'; //Študijska srečanja
import ZrssPrijavnicaVp2021 from './views/prijavnica-vp-2021.vue'; //Študijska srečanja
import ZrssPrijavnicaTm2021 from './views/prijavnica-tm-2021.vue'; //Trajnostna mobilnost
import PrijavnicaList from './views/list.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/svetovanje',
            name: 'prijavnica',
            component: ZrssPrijavnica,
        },
        {
            path: '/list',
            name: 'list',
            component: PrijavnicaList,
        },
        {
            path: '/ss2021',
            name: 'prijavnica-studijska-srecanja',
            component: ZrssPrijavnicaSS,
        },
        {
            path: '/',
            name: 'prijavnica-vizualna-pismenost',
            component: ZrssPrijavnicaVp2021,
        },
        {
            path: '/nak',
            name: 'prijavnica-nak',
            component: ZrssPrijavnicaNAK,
        },
        {
            path: '/tm',
            name: 'prijavnica-tm2021',
            component: ZrssPrijavnicaTm2021,
        },
    ],
});
